/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RptAgendaCommercialeDtoFromJSON, RptAgendaCommercialeDtoToJSON, } from './RptAgendaCommercialeDto';
/**
 * Check if a given object implements the RptAgendaCommercialePagedDto interface.
 */
export function instanceOfRptAgendaCommercialePagedDto(value) {
    return true;
}
export function RptAgendaCommercialePagedDtoFromJSON(json) {
    return RptAgendaCommercialePagedDtoFromJSONTyped(json, false);
}
export function RptAgendaCommercialePagedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'] == null ? undefined : (json['content'].map(RptAgendaCommercialeDtoFromJSON)),
        'size': json['size'] == null ? undefined : json['size'],
        'page': json['page'] == null ? undefined : json['page'],
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}
export function RptAgendaCommercialePagedDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'] == null ? undefined : (value['content'].map(RptAgendaCommercialeDtoToJSON)),
        'size': value['size'],
        'page': value['page'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}
